<template>
  <Modal v-model="visible" :title="title" width="560" :mask-closable="false" transfer>
    <Form :label-width="110" :show-message="false" label-position="right">
      <Form-item label="外教">
        <span>{{ tchText }}</span>
        <span v-if="row && row.country" class="muted">· {{ row.country }}</span>
      </Form-item>
      <Form-item label="入职日 / 到期日">
        <span>{{ (row && row.hireDate) || '—' }} ~ {{ (row && row.probationEnd) || '—' }}</span>
        <span v-if="row && row.daysLeft != null" class="muted">（{{ daysLabel }}）</span>
      </Form-item>
      <Form-item label="评估结论" required>
        <Radio-group v-model="form.result">
          <Radio v-for="(item, code) in resultDict" :key="code" :label="code">{{ item.text }}</Radio>
        </Radio-group>
      </Form-item>
      <Form-item v-if="form.result === 'EXTENDED'" label="延长月数" required>
        <InputNumber v-model="form.extendMonths" :min="1" :max="6" :step="1"></InputNumber>
        <span class="muted">个月（1–6）</span>
      </Form-item>
      <Form-item v-if="form.result === 'CONVERTED'" label="新合同起止">
        <Date-picker type="date" :value="form.crtBeginDate" placeholder="起始日" transfer
                     style="width: 150px;" @on-change="form.crtBeginDate = $event"></Date-picker>
        <span class="muted">至</span>
        <Date-picker type="date" :value="form.crtEndDate" placeholder="到期日" transfer
                     style="width: 150px;" @on-change="form.crtEndDate = $event"></Date-picker>
        <div class="muted">可留空；填了会同时更新老师合同起止</div>
      </Form-item>
      <Form-item v-if="form.result === 'TERMINATED'" label=" ">
        <Alert type="warning" show-icon>只记录结论，不改老师状态；离职请到「老师管理」走现有离职流程</Alert>
      </Form-item>
      <Form-item label="评估备注">
        <Input v-model="form.note" type="textarea" :rows="3" :maxlength="1000"
               placeholder="课堂表现、出勤、家长反馈等"></Input>
      </Form-item>
    </Form>
    <div slot="footer">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" :loading="saving" @click="submit">提交结论</Button>
    </div>
  </Modal>
</template>
<script>
import { API_PREFIX, PROBATION_RESULT, tchLabel, daysText } from '../constants'
function emptyForm () {
  return {
    result: 'CONVERTED',
    extendMonths: 1,
    crtBeginDate: '',
    crtEndDate: '',
    note: ''
  }
}
export default {
  name: 'ProbationDecideModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      visible: false,
      saving: false,
      resultDict: PROBATION_RESULT,
      form: emptyForm()
    }
  },
  computed: {
    tchText () {
      let r = this.row
      if (!r) {
        return '—'
      }
      return tchLabel(r) + '（ID ' + r.tchId + '）'
    },
    title () {
      return '试用期结论 · ' + (tchLabel(this.row) || '')
    },
    daysLabel () {
      return daysText(this.row && this.row.daysLeft)
    }
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        this.form = emptyForm()
      }
    },
    visible (val) {
      if (val === false) {
        this.$emit('on-close')
      }
    }
  },
  methods: {
    submit () {
      let self = this
      let f = self.form
      if (!self.row || !self.row.tchId) {
        return
      }
      if (!f.result) {
        self.$Message.warning('请选择评估结论')
        return
      }
      let params = { tchId: self.row.tchId, result: f.result, note: f.note }
      if (f.result === 'EXTENDED') {
        if (!f.extendMonths || f.extendMonths < 1 || f.extendMonths > 6) {
          self.$Message.warning('延长月数需为 1–6')
          return
        }
        params.extendMonths = f.extendMonths
      }
      if (f.result === 'CONVERTED') {
        if ((f.crtBeginDate && !f.crtEndDate) || (!f.crtBeginDate && f.crtEndDate)) {
          self.$Message.warning('新合同起止需同时填写或都留空')
          return
        }
        if (f.crtBeginDate && f.crtEndDate) {
          if (f.crtBeginDate > f.crtEndDate) {
            self.$Message.warning('到期日不能早于起始日')
            return
          }
          params.crtBeginDate = f.crtBeginDate
          params.crtEndDate = f.crtEndDate
        }
      }
      self.saving = true
      self.$http.post(API_PREFIX + '/probation/decide', params).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('已提交试用期结论')
          self.visible = false
          self.$root.$emit('hr-badges-refresh')
          self.$emit('on-success')
        }
      }).finally(function () {
        self.saving = false
      })
    }
  }
}
</script>
<style scoped lang="less">
.muted {
  margin-left: 6px;
  color: #8B93A7;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// ProbationDecideModal.vue?df8a58ce